export const getDate = (date) => new Date(date)
export const getMonth = (date) => getDate(date).getMonth()
export const getYear = (date) => getDate(date).getFullYear()

export const getSeason = (date) => Math.floor((getMonth(date) / 12) * 4) % 4
export const getIdentifier = (date) => `${getYear(date)}.${getMonth(date) + 1}`

export const getDayLabels = () => {
  const data = [
    '$t(DATE_DAY_MON)',
    '$t(DATE_DAY_TUE)',
    '$t(DATE_DAY_WED)',
    '$t(DATE_DAY_THU)',
    '$t(DATE_DAY_FRI)',
    '$t(DATE_DAY_SAT)',
    '$t(DATE_DAY_SUN)'
  ]
  return data
}

export const getMonthLabels = () => {
  const data = [
    '$t(DATE_MONTH_JAN)',
    '$t(DATE_MONTH_FEB)',
    '$t(DATE_MONTH_MAR)',
    '$t(DATE_MONTH_APR)',
    '$t(DATE_MONTH_MAY)',
    '$t(DATE_MONTH_JUN)',
    '$t(DATE_MONTH_JUL)',
    '$t(DATE_MONTH_AUG)',
    '$t(DATE_MONTH_SEP)',
    '$t(DATE_MONTH_OCT)',
    '$t(DATE_MONTH_NOV)',
    '$t(DATE_MONTH_DEC)'
  ]
  return data
}

// Used for date calculations
export const getMonthLabelsEnglish = () => [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]
export const getDayLabelsEnglish = () => ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

export const getDateLabel = (dateRaw, lang) => {
  const date = getDate(dateRaw)
  const dayLabelData = reorderDayLabels()
  let dateLabel = ''
  switch (lang) {
    case 'nl':
      dateLabel = `${dayLabelData[date.getDay()]} ${date.getDate()} ${
        getMonthLabels()[getDate(date).getMonth()]
      } ${getDate(date).getUTCFullYear()}`
      break
    case 'en':
    case 'ro':
    case 'md':
      dateLabel = `${dayLabelData[date.getDay()]}, ${
        getMonthLabels()[getDate(date).getMonth()]
      } ${date.getDate()}, ${getDate(date).getUTCFullYear()}`
      break
    default:
  }
  return dateLabel
}

export const getDateLabelMedium = (dateRaw, lang) => {
  const date = getDate(dateRaw)
  let dateLabel = ''
  switch (lang) {
    case 'nl':
      dateLabel = `${date.getDate()} ${getMonthLabels()[getDate(date).getMonth()]}`
      break
    case 'en':
    case 'ro':
    case 'md':
      dateLabel = `${date.getDate()} ${getMonthLabels()[getDate(date).getMonth()]}`
      break
    default:
      return `${date.getDate()} ${getMonthLabels()[getDate(date).getMonth()]}`
  }
  return dateLabel
}

export const getMonthsWithPlans = (items) => {
  const monthsWithPlans = []
  items?.forEach((item) => {
    if (item?.blueprint?.id) {
      const identifier = getIdentifier(item.date)
      if (!monthsWithPlans.includes(identifier)) monthsWithPlans.push(identifier)
    }
  })
  return monthsWithPlans
}

export const getSeasonMonths = (seasonStart, seasonEnd, t) => {
  const monthsList = []
  const months = getMonthLabels(t)
  const startMonth = getMonth(seasonStart)
  const startYear = getYear(seasonStart)
  const endMonth = getMonth(seasonEnd)
  const endYear = getYear(seasonEnd)

  const getStartYearMonths = () => {
    const startYearMonths = []
    for (let i = startMonth; i < months.length; i++) {
      startYearMonths.push({
        label: months[i],
        index: i
      })
    }
    return startYearMonths
  }

  const getEndYearMonths = () => {
    const endYearMonths = []
    for (let i = endMonth; i >= 0; i--) {
      endYearMonths.push({
        label: months[i],
        index: i
      })
    }
    return endYearMonths.reverse()
  }

  if (startYear !== endYear) monthsList.push({ year: startYear, months: getStartYearMonths() })
  monthsList.push({ year: endYear, months: getEndYearMonths() })

  return monthsList
}

export const reorderDayLabels = () => {
  const days = getDayLabels()
  const sunLbl = '$t(DATE_DAY_SUN)'
  const sunInx = days.findIndex((el) => el === sunLbl)
  const obj = days
  obj.splice(sunInx, 1)
  obj.unshift(sunLbl)
  return obj
}
